import RefClient from 'ref-client-core';
import flexPolylineFormViewPlugin from './flexPolylineFormView';
import maneuversVisualizationPlugin from './maneuversVisualization';
import maneuversVisualizationPluginButton from './maneuversVisualizationButton';
import distanceMeasurementFormView from './distanceMeasurement';
import gpxTraceFormView from './gpxTraceFormView';
import FlexPolylineResult from './FlexPolylineResult';
import gpxTraceResult from './gpxTraceResult';

RefClient.formViewsPlugin.register('flexPolylineFormView', flexPolylineFormViewPlugin);
RefClient.formViewsPlugin.register('distanceMeasurementFormView', distanceMeasurementFormView);
RefClient.formViewsPlugin.register('gpxTraceFormView', gpxTraceFormView);
RefClient.resultPanelPlugin.register('flexPolylineResult', FlexPolylineResult);
RefClient.resultPanelPlugin.register('gpxTraceResult', gpxTraceResult);
RefClient.formViewsPlugin.register('maneuversVisualization', maneuversVisualizationPlugin);
RefClient.formViewsPlugin.register('maneuversVisualizationButton', maneuversVisualizationPluginButton);
